import { useParams, useNavigate } from "react-router-dom";
import Layout from "../Layout";
import styled from "styled-components";
import { useEffect } from "react";

const ConfiguratorPage = () => {
  const { kitchenName } = useParams<{ kitchenName: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!kitchenName) {
      // Redirect to home if no kitchen is selected
      navigate('/');
    }
  }, [kitchenName, navigate]);

  return (
    <PageContainer>
      <BackButton onClick={() => navigate('/')}>
        ← Retour à la sélection
      </BackButton>
      <Layout initialKitchen={kitchenName || 'Campagne'} />
    </PageContainer>
  );
};

const PageContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const BackButton = styled.button`
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 1000;
  padding: 0.75rem 1.5rem;
  background: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  
  &:hover {
    background: #f0f0f0;
    transform: translateX(-4px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }
`;

export default ConfiguratorPage;
